import { Clock, Users, Calendar, Info } from 'lucide-react';
import Card from '../components/ui/Card';
import ReservationForm from '../components/reservation/ReservationForm';
import { useLanguage } from '../context/LanguageContext';

export default function Reservation() {
  const { t, language } = useLanguage();

  const infoItems = t('reservationPage.info.items');

  return (
    <div className="min-h-screen bg-cream-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-primary-800 dark:bg-primary-900 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('reservationPage.title')}
          </h1>
          <p className="text-lg text-primary-200 max-w-2xl mx-auto">
            {t('reservationPage.subtitle')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Form */}
          <div className="lg:col-span-2">
            <Card>
              <ReservationForm />
            </Card>
          </div>

          {/* Info Sidebar */}
          <div className="space-y-6">
            {/* Info Card */}
            <Card>
              <div className="flex items-center gap-3 mb-4">
                <Info className="w-5 h-5 text-primary-600 dark:text-primary-400" />
                <h3 className="font-semibold text-gray-900 dark:text-white">
                  {t('reservationPage.info.title')}
                </h3>
              </div>
              <ul className="space-y-3">
                {infoItems.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-2 text-gray-600 dark:text-gray-400 text-sm"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </Card>

            {/* Quick Info Cards */}
            <Card className="flex items-center gap-4">
              <div className="p-3 bg-cream-100 dark:bg-gray-700 rounded-xl">
                <Clock className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <div>
                <p className="font-medium text-gray-900 dark:text-white">
                  {language === 'de' ? 'Öffnungszeiten' : 'Opening Hours'}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Di-Sa 12-23 Uhr, So 12-22 Uhr
                </p>
              </div>
            </Card>

            <Card className="flex items-center gap-4">
              <div className="p-3 bg-cream-100 dark:bg-gray-700 rounded-xl">
                <Users className="w-6 h-6 text-accent-600 dark:text-accent-400" />
              </div>
              <div>
                <p className="font-medium text-gray-900 dark:text-white">
                  {language === 'de' ? 'Gruppen' : 'Groups'}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {language === 'de'
                    ? 'Für 8+ Personen bitte anrufen'
                    : 'For 8+ persons please call'}
                </p>
              </div>
            </Card>

            <Card className="flex items-center gap-4">
              <div className="p-3 bg-cream-100 dark:bg-gray-700 rounded-xl">
                <Calendar className="w-6 h-6 text-wine-600 dark:text-wine-400" />
              </div>
              <div>
                <p className="font-medium text-gray-900 dark:text-white">
                  {language === 'de' ? 'Ruhetag' : 'Closed'}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {language === 'de' ? 'Montags geschlossen' : 'Closed on Mondays'}
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
